import {
  Projecto73xqbcrzskm as Project,
  Companion_getInstancefq4vwlyjorqo as Companion_getInstance,
  Companion_getInstance1t0noik4ocb5x as Companion_getInstance_0,
  Companion_getInstance307sotgyzbnou as Companion_getInstance_1,
  Companion_getInstance124t3fbljdbyi as Companion_getInstance_2,
  Companion_getInstance1b21bhtdgqkve as Companion_getInstance_3,
  Companion_getInstance3r9dph6rgwho0 as Companion_getInstance_4,
  Companion_getInstancee6k6ib2dkotb as Companion_getInstance_5,
  Companion_getInstancex3rnna8pnr6f as Companion_getInstance_6,
  Companion_getInstance20myouriyv3u as Companion_getInstance_7,
  Companion_getInstance11rxtahezlto7 as Companion_getInstance_8,
  Companion_getInstance1cdih9ztewhpv as Companion_getInstance_9,
  Companion_getInstance2m617r7l2yg9j as Companion_getInstance_10,
  Companion_getInstance2eaghgpohvp5v as Companion_getInstance_11,
  Companion_getInstance14mfei2uzw3x6 as Companion_getInstance_12,
  Companion_getInstance30idiynnpnbn2 as Companion_getInstance_13,
  Companion_getInstanceha7z78i7nvow as Companion_getInstance_14,
  Companion_instance2x6o1nijtl11 as Companion_instance,
  Companion_instancevwupp4fz0ehs as Companion_instance_0,
  Companion_getInstance3bisd6gjnm0oz as Companion_getInstance_15,
  Companion_getInstance21u335vgn0mpe as Companion_getInstance_16,
  Companion_getInstance12ven2xbljkm0 as Companion_getInstance_17,
  Companion_getInstance1h9pz6hxur4uj as Companion_getInstance_18,
  Companion_getInstance28gwov6pby7lz as Companion_getInstance_19,
  Companion_getInstance1moufct3sbct9 as Companion_getInstance_20,
  Companion_getInstance3lubwpz5lc00p as Companion_getInstance_21,
  Companion_getInstance1z8if8hzu5ng5 as Companion_getInstance_22,
  Companion_getInstanceh1cmko92158x as Companion_getInstance_23,
  Companion_getInstance12sgbyys5mml7 as Companion_getInstance_24,
  Companion_getInstancezuwazqbeik8p as Companion_getInstance_25,
  Companion_getInstance1up45os1rj3ws as Companion_getInstance_26,
  Companion_getInstance1cc7a4v9g7e6l as Companion_getInstance_27,
  Companion_getInstance3ar1by5trsbn7 as Companion_getInstance_28,
  Companion_getInstance241hfcdeiz4z5 as Companion_getInstance_29,
  Companion_getInstancexfdqyjk2ykmw as Companion_getInstance_30,
} from '../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  Companion_instancek13g6rikuawd as Companion_instance_1,
  And3abx79zpqd7r8 as And,
  orNotNull29zbfwadzwyme as orNotNull,
} from '../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import {
  get_customer1w9vmrtgthst as get_customer,
  get_contractor2weo1umt9id6t as get_contractor,
  get_state23zbf4that7g as get_state,
  get_created373kmke1rp67y as get_created,
} from '../../../../crowpay-shared/com/crowpay/ProjectFields.mjs';
import {
  eq1298m2cje971u as eq,
  xDataClassPathNotInSet2lprzz67ddi7c as xDataClassPathNotInSet,
} from '../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { get_selectedContractor2m4vxuqdzv6k3 as get_selectedContractor } from '../selectedContractor.mjs';
import {
  Companion_getInstance1toq7c46z6qs1 as Companion_getInstance_31,
  ProjectState_Creating_getInstancegu71uom71mst as ProjectState_Creating_getInstance,
} from '../../../../crowpay-shared/com/crowpay/enums.mjs';
import { get_inactiveStates2yk2ks5kh401v as get_inactiveStates } from '../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { plus18eogev54fmsa as plus } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { ModelCache1j2q0r8bmhrox as ModelCache } from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/ModelCache.mjs';
import {
  ReadByModelCache3hp3dxfu3dctp as ReadByModelCache,
  ReadByWithCreditsModelCache2966rfs5sxwfi as ReadByWithCreditsModelCache,
  ReadByWithFeedbackModelCachew7asb05bgew9 as ReadByWithFeedbackModelCache,
  Companion_getInstance24j3x2uirrx0g as Companion_getInstance_32,
} from './ReadByModelCache.mjs';
import {
  Companion_getInstance2tq82jyrde4r as Companion_getInstance_33,
  Companion_getInstance2a6946bmnnmyk as Companion_getInstance_34,
} from '../../../../crowpay-shared/com/crowpay/notifications/shared.mjs';
import { UUIDSerializer_getInstance2ms0oa88en0c as UUIDSerializer_getInstance } from '../../../../lightning-server-shared/com/lightningkite/serialization/Serializers.mjs';
import {
  Companion_getInstancem5ekhykter02 as Companion_getInstance_35,
  AccessInfoj60d6hx1qs8r as AccessInfo,
} from '../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { System_instance3dr57gee6r420 as System_instance } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { accessTokenh4ztdznrxzfp as accessToken } from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/auth/authInterfaces.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  BasicListenable3uz4a8xs34a0h as BasicListenable,
} from '../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { awaitqeg6zusi9ora as await_0 } from '../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_selectedApi2skzkr2pn0lot as get_selectedApi } from './apiOptions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../../../../kiteui-library/com/lightningkite/kiteui/reactive/PersistentProperty.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_sessionToken() {
  _init_properties_UserSession_kt__s0gvl3();
  return sessionToken;
}
var sessionToken;
function get_invalidateAccess() {
  _init_properties_UserSession_kt__s0gvl3();
  return invalidateAccess;
}
var invalidateAccess;
function get_rawSession() {
  _init_properties_UserSession_kt__s0gvl3();
  return rawSession;
}
var rawSession;
function get_sessionNotFound() {
  _init_properties_UserSession_kt__s0gvl3();
  return sessionNotFound;
}
var sessionNotFound;
function get_session() {
  _init_properties_UserSession_kt__s0gvl3();
  return session;
}
var session;
function UserSession$myProjects$lambda($this$remember) {
  var session = $this$remember.baj(get_session());
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
  // Inline function 'kotlin.let' call
  var project = new (DataClassPathSelf())(tmp$ret$0);
  var tmp_0 = Companion_instance_1;
  var tmp_1 = eq(get_customer(project), session.efv_1);
  var tmp0_safe_receiver = $this$remember.baj(get_selectedContractor());
  var tmp_2;
  if (tmp0_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_2 = eq(get_contractor(project), tmp0_safe_receiver);
  }
  var tmp0_condition = And().x3q([orNotNull(tmp_0, [tmp_1, tmp_2]), xDataClassPathNotInSet(get_state(project), plus(get_inactiveStates(Companion_getInstance_31()), ProjectState_Creating_getInstance()))]);
  var tmp1_limit = 2147483647;
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_3 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
  var tmp$ret$7 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$7);
  this_0.m4a(get_created(it));
  var tmp2_orderBy = this_0.o1r();
  return $this$remember.baj(session.pfv_1.feo(new (Query())(tmp0_condition, tmp2_orderBy, VOID, tmp1_limit)));
}
var UserSessionClass;
function UserSession() {
  if (UserSessionClass === VOID) {
    class $ {
      constructor(api, userId) {
        this.dfv_1 = api;
        this.efv_1 = userId;
        this.ffv_1 = new (ModelCache())(this.tfw().pff_1, Companion_getInstance().m2a());
        this.gfv_1 = new (ModelCache())(this.tfw().cfg_1, Companion_getInstance_0().m2a());
        this.hfv_1 = ReadByModelCache().aft(this.efv_1, this.tfw().jff_1, Companion_getInstance_1().m2a());
        this.ifv_1 = new (ModelCache())(this.tfw().kff_1, Companion_getInstance_2().m2a());
        this.jfv_1 = new (ModelCache())(this.tfw().mff_1, Companion_getInstance_3().m2a());
        this.kfv_1 = new (ModelCache())(this.tfw().nff_1, Companion_getInstance_4().m2a());
        this.lfv_1 = new (ModelCache())(this.tfw().dfg_1, Companion_getInstance_5().m2a());
        this.mfv_1 = ReadByWithCreditsModelCache().gfu(this.efv_1, this.tfw().efg_1, Companion_getInstance_6().m2a());
        this.nfv_1 = ReadByModelCache().aft(this.efv_1, this.tfw().bfg_1, Companion_getInstance_7().m2a());
        this.ofv_1 = new (ModelCache())(this.tfw().xfg_1, Companion_getInstance_8().m2a());
        this.pfv_1 = ReadByWithCreditsModelCache().gfu(this.efv_1, this.tfw().pfg_1, Companion_getInstance_9().m2a());
        this.qfv_1 = new (ModelCache())(this.tfw().qfg_1, Companion_getInstance_10().m2a());
        this.rfv_1 = ReadByModelCache().aft(this.efv_1, this.tfw().ufg_1, Companion_getInstance_11().m2a());
        this.sfv_1 = ReadByWithFeedbackModelCache().tft(this.efv_1, this.tfw().ofg_1, Companion_getInstance_12().m2a());
        this.tfv_1 = ReadByWithFeedbackModelCache().tft(this.efv_1, this.tfw().nfg_1, Companion_getInstance_13().m2a());
        this.ufv_1 = ReadByModelCache().aft(this.efv_1, this.tfw().vfg_1, Companion_getInstance_14().m2a());
        this.vfv_1 = new (ModelCache())(this.tfw().yfg_1, Companion_instance.m2a());
        this.wfv_1 = new (ModelCache())(this.tfw().tff_1, Companion_instance_0.m2a());
        this.xfv_1 = new (ModelCache())(this.tfw().iff_1, Companion_getInstance_15().m2a());
        this.yfv_1 = new (ModelCache())(this.tfw().afh_1, Companion_getInstance_16().m2a());
        this.zfv_1 = ReadByModelCache().aft(this.efv_1, this.tfw().off_1, Companion_getInstance_17().m2a());
        this.afw_1 = ReadByModelCache().aft(this.efv_1, this.tfw().lfg_1, Companion_getInstance_18().m2a());
        this.bfw_1 = ReadByWithFeedbackModelCache().tft(this.efv_1, this.tfw().kfg_1, Companion_getInstance_19().m2a());
        this.cfw_1 = ReadByModelCache().aft(this.efv_1, this.tfw().ffg_1, Companion_getInstance_20().m2a());
        this.dfw_1 = new (ModelCache())(this.tfw().tfg_1, Companion_getInstance_21().m2a());
        this.efw_1 = ReadByModelCache().aft(this.efv_1, this.tfw().lff_1, Companion_getInstance_22().m2a());
        this.ffw_1 = new (ModelCache())(this.tfw().rff_1, Companion_getInstance_23().m2a());
        this.gfw_1 = ReadByModelCache().aft(this.efv_1, this.tfw().yff_1, Companion_getInstance_24().m2a());
        this.hfw_1 = ReadByModelCache().aft(this.efv_1, this.tfw().zff_1, Companion_getInstance_25().m2a());
        this.ifw_1 = ReadByModelCache().aft(this.efv_1, this.tfw().afg_1, Companion_getInstance_26().m2a());
        this.jfw_1 = ReadByModelCache().aft(this.efv_1, this.tfw().rfg_1, Companion_getInstance_27().m2a());
        this.kfw_1 = new (ModelCache())(this.tfw().hfg_1, Companion_getInstance_33().i8m(UUIDSerializer_getInstance(), Companion_getInstance_35().m2a()));
        this.lfw_1 = new (ModelCache())(this.tfw().uff_1, Companion_getInstance_34().e8k(UUIDSerializer_getInstance()));
        this.mfw_1 = new (ModelCache())(this.tfw().sfg_1, Companion_getInstance_28().m2a());
        this.nfw_1 = new (ModelCache())(this.tfw().zfg_1, Companion_getInstance_29().m2a());
        this.ofw_1 = new (ModelCache())(this.tfw().vff_1, Companion_getInstance_30().m2a());
        var tmp = this;
        tmp.pfw_1 = remember(VOID, VOID, VOID, ($this$remember) => ensureNotNull($this$remember.baj(this.yfv_1.eeo(this.efv_1))));
        var tmp_0 = this;
        tmp_0.qfw_1 = remember(VOID, VOID, VOID, UserSession$myProjects$lambda);
      }
      tfw() {
        return this.dfv_1;
      }
      ufw() {
        return new (AccessInfo())(this.efv_1, '', VOID, '', System_instance.d1m());
      }
    }
    initMetadataForClass($, 'UserSession');
    UserSessionClass = $;
  }
  return UserSessionClass;
}
function withAccessToken(_this__u8e3s4, token, invalidate) {
  invalidate = invalidate === VOID ? null : invalidate;
  _init_properties_UserSession_kt__s0gvl3();
  return _this__u8e3s4.req(accessToken(_this__u8e3s4.bfh_1, token, invalidate));
}
function lensUnread(_this__u8e3s4, unread) {
  _init_properties_UserSession_kt__s0gvl3();
  return new (Constant())(_Constant___init__impl__v45mub(Companion_getInstance_32().dft_1));
}
function *_generator_invoke__zhh2q8($this, $this$rememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_sessionToken();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var token = tmp_0;
  var tmp_1;
  try {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_selectedApi();
    var tmp_2 = await_0(this_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp$ret$1 = tmp_2;
    tmp_1 = withAccessToken(tmp$ret$1.bfx(), token, get_invalidateAccess());
  } catch ($p) {
    var tmp_3;
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3 = $p;
      return null;
    } else {
      throw $p;
    }
  }
  var api = tmp_1;
  var tmp_4;
  try {
    var tmp_5 = api.bfh_1.yei($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    tmp_4 = tmp_5;
  } catch ($p) {
    var tmp_6;
    if ($p instanceof Exception()) {
      var _unused_var__etf5q3_0 = $p;
      return null;
    } else {
      throw $p;
    }
  }
  var self_0 = tmp_4;
  return new (UserSession())(api, self_0.f88_1);
}
var rawSession$slambdaClass;
function rawSession$slambda() {
  if (rawSession$slambdaClass === VOID) {
    class $ {
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    rawSession$slambdaClass = $;
  }
  return rawSession$slambdaClass;
}
function rawSession$slambda_0() {
  var i = new (rawSession$slambda())();
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function session$lambda($this$remember) {
  _init_properties_UserSession_kt__s0gvl3();
  var result = $this$remember.baj(get_rawSession());
  if (result == null) {
    get_sessionNotFound().oaq();
    throw CancellationException().ld('No auth');
  }
  return result;
}
var properties_initialized_UserSession_kt_96vvmt;
function _init_properties_UserSession_kt__s0gvl3() {
  if (!properties_initialized_UserSession_kt_96vvmt) {
    properties_initialized_UserSession_kt_96vvmt = true;
    // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call
    var key = 'sessionToken';
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer(createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), true));
    var tmp$ret$1 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
    sessionToken = PersistentProperty().od8(key, null, tmp$ret$1);
    invalidateAccess = BasicListenable().naq();
    rawSession = rememberSuspending(VOID, VOID, VOID, rawSession$slambda_0());
    sessionNotFound = BasicListenable().naq();
    session = remember(VOID, VOID, VOID, session$lambda);
  }
}
//region block: exports
export {
  get_invalidateAccess as get_invalidateAccess2sldhktdow8gg,
  lensUnread as lensUnread1tcpdysie4g78,
  get_rawSession as get_rawSession1kjo1nj4tz6n0,
  get_session as get_session9cytjmfbg8nd,
  get_sessionNotFound as get_sessionNotFound2vlo9fobx2iqb,
  get_sessionToken as get_sessionToken1e5yonv6d457l,
};
//endregion

//# sourceMappingURL=UserSession.mjs.map
